import { Trans } from "@lingui/react/macro";
import { useState } from "react";

import { ApiConnector } from "../../api/api-connector";
import { Button } from "../../components/ui-kit/button";
import { FormRow } from "../../components/ui-kit/form/form-row";
import { FormTable } from "../../components/ui-kit/form/form-table";
import { ChangePasswordDialog } from "./change-password-dialog";

export function AccountRoute({ api }: { api: ApiConnector }) {
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <>
      <FormTable dataAdd>
        <FormRow
          label={<Trans>Username</Trans>}
          data={<span>{api.username}</span>}
        />

        <FormRow
          label={<Trans>Password</Trans>}
          data={
            <Button
              onClick={() => {
                setShowChangePassword(true);
              }}
            >
              <Trans>Change Password</Trans>
            </Button>
          }
        />
      </FormTable>

      {showChangePassword && (
        <ChangePasswordDialog
          api={api}
          onClose={() => setShowChangePassword(false)}
        />
      )}
    </>
  );
}
